import React from "react";
import type { Training } from "../../../../api/training/Training.typed";
import type { TheoryTestTemplate } from "../../../../api/theoryTests/TheoryTest.typed";
import { useTraining } from "../../../../contexts/api";

export function useTheoryTestTemplate(training: Training) {
  const { getTheoryTestTemplate } = useTraining();
  const tests = training.TheoryTests ?? [];
  const templateId = tests[0]?.TrainingTemplateID ?? null;
  const [template, setTemplate] = React.useState<TheoryTestTemplate | null>(null);

  React.useEffect(() => {
    if (templateId == null) return;
    let isMounted = true;
    getTheoryTestTemplate(templateId).then((templateData) => {
      if (isMounted && templateData) setTemplate(templateData);
    });
    return () => {
      isMounted = false;
    };
  }, [getTheoryTestTemplate, templateId]);

  return { template, tests };
}
